import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import OlCollection from 'ol/Collection';
import * as olEventsCondition from 'ol/events/condition';
import { Polygon as OlPolygon } from 'ol/geom';
import OlDraw from 'ol/interaction/Draw';
import OlModify from 'ol/interaction/Modify';
import { MapWrapper } from '@openlayers/MapWrapper';
import { GeofenceFeatureFactory } from '@shared/trucks/GeofenceFeatureFactory';

export class GeofenceDraw {
    source = new VectorSource();

    layer = new VectorLayer({
        source: this.source,
    });

    drawInteraction: OlDraw;
    modifyInteraction: OlModify;
    currentFeature: Feature;
    currentGeofence: IGeofence;
    originalGeometry: Coordinate[][]; // to restore on cancel

    constructor(private mapWrapper: MapWrapper) {}

    startDrawing() {
        const mapInstance = this.mapWrapper.getInstance();
        mapInstance.removeInteraction(this.modifyInteraction);
        mapInstance.removeInteraction(this.drawInteraction);
        this.mapWrapper.addLayer(this.layer, 105, 'draw-geofence');

        this.drawInteraction = new OlDraw({
            source: this.source,
            type: 'Polygon',
        });
        mapInstance.addInteraction(this.drawInteraction);

        this.drawInteraction.on('drawend', ({ feature }) => {
            this.startModifyFeature(feature);
        });
    }

    startModifyFeature(feature: Feature, addLayerToMap = false) {
        const mapInstance = this.mapWrapper.getInstance();
        mapInstance.removeInteraction(this.modifyInteraction);
        mapInstance.removeInteraction(this.drawInteraction);

        if (addLayerToMap) {
            this.source.addFeature(feature);
            this.mapWrapper.addLayer(this.layer, 1005, 'modify-geofence');
        }

        const features: OlCollection<Feature> = new OlCollection();
        features.push(feature);
        this.currentFeature = feature;
        this.originalGeometry = (feature.getGeometry() as OlPolygon).getCoordinates();

        this.currentFeature.setStyle(GeofenceFeatureFactory.styles.dashed[this.currentGeofence?.type ?? 0]);

        this.modifyInteraction = new OlModify({
            features,
            deleteCondition: event => olEventsCondition.shiftKeyOnly(event) && olEventsCondition.singleClick(event),
        });

        mapInstance.addInteraction(this.modifyInteraction);
    }

    startModify(geofence: IGeofence, feature: Feature) {
        if (!feature) {
            console.warn('No geofence feature found');
            return;
        }
        this.currentGeofence = geofence;
        this.startModifyFeature(feature);
    }

    cancel() {
        const mapInstance = this.mapWrapper.getInstance();
        if (this.currentGeofence) {
            this.currentFeature.setStyle(GeofenceFeatureFactory.styles.normal[this.currentGeofence.type]);
        }

        if (this.currentFeature && this.currentGeofence) {
            (this.currentFeature.getGeometry() as OlPolygon).setCoordinates(this.originalGeometry);
            this.currentFeature = null;
            this.originalGeometry = null;
        }

        if (this.modifyInteraction) {
            mapInstance.removeInteraction(this.modifyInteraction);
        }
        if (this.drawInteraction) {
            mapInstance.removeInteraction(this.drawInteraction);
        }

        this.currentGeofence = null;
        this.source.clear();
        this.mapWrapper.removeLayer(this.layer);
    }
}
